<template>
  <div
    v-if="rating"
    class="card"
  >
    <defaqto-sticker
      class="card__sticker"
      :rating="rating"
    />
    <p class="card__description">
      Defaqto is an independent financial research company. It independently
      assesses all products in the market, and gives each a rating from 1 to 5
      stars based on the quality and comprehensiveness of the features and
      benefits it offers.
    </p>
  </div>
</template>

<script>
import DefaqtoSticker from '@/components/Rating/DefaqtoSticker';
export default {
  name: 'defaqto-info-card',
  components: { DefaqtoSticker },
  props: {
    rating: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
  .card {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 35px;
    padding: 20px 25px;
    background-color: $clr-white;
    border: 1px solid $clr-outline;
    border-radius: 6px;
    text-align: left;

    &__sticker {
      overflow-x: visible;
      width: 50%;
    }

    &__description {
      margin-top: 10px;
      margin-bottom: 0;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      text-align: left;
    }
  }
</style>
